import close from "../../assets/images/components/close.png";
const DizeeCloseIcon = (className) => {
  <img src={close} alt="check" className={className} />;
};
export default DizeeCloseIcon;
